export const Debounce = (func, delay) => {
    let timeoutId;
  
    return (...args) => {
      // Clear the previous timeout
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
  
      // Set a new timeout to invoke the function after the delay
      timeoutId = setTimeout(() => {
        func(...args);
      }, delay);
    };
  };
  